import { useAppointmentPermissions } from 'hooks/useAppointmentPermissions.hook';
import { canShowCreateActionInColumn } from 'utils/predicates/scheduler/canShowCreateActionInColumn.util';

/**
 * Hides "New appointment" when can_create_appointment is no_access, or personal on another stylist's column.
 */
const BookApptGatedByPermissions = ({ columnStylistId, onClick, label, dataBem, className }) => {
  const appointmentPerms = useAppointmentPermissions();

  if (!canShowCreateActionInColumn({ columnStylistId, ...appointmentPerms })) return null;

  return (
    <button data-bem={dataBem || undefined} onClick={onClick} className={className} type="button">
      {label}
    </button>
  );
};

export default BookApptGatedByPermissions;
